import React, { useCallback, useMemo, useState } from 'react';
import { useRequest } from 'ahooks';
import Panel from '../index';
import { RadialBar } from '@ant-design/charts';
import { Spin } from 'antd';
import { GetServiceEffectAnalyse} from '@/services/api';
import cn from 'classnames'
import styles from './index.module.scss';
import ImgSource from '@/assets/img/tingchenan/tingcheliyonglv.png'
export interface ParkingUsageProps {
  areaCode?: string;
}


const colors = ['#FEC849', '#315AFA', '#00A8FE', '#66CE97', '#3E77D4'];
const KeyCarTable: React.FC<ParkingUsageProps> = ({ areaCode }) => {
 
 
 const { data: parkuseRateData=[], loading, error } = useRequest(useCallback(() => {
    return GetServiceEffectAnalyse({areaCode});
  }, [areaCode]), {
    formatResult: res => {
      return res.data.map((item:any,index:number)=>{
        return {
          name:item.textName,
          value:item.rate,
          index:index
        }
      })
    },
    refreshDeps: [areaCode]
  })
  

  

  if (loading) {
    return (
      <Panel title="服务成效分析" >
        <div className="fetch_container" style={{ height: 200 }}>
          <Spin />
        </div>
      </Panel>
    )
  }

  if (error) {
    return (
      <Panel title="服务成效分析"  >
        <div className="fetch_container" style={{ height: 200 }}>
          请求错误
        </div>
      </Panel>
    )
  }
  
  // const defaultData = {
  //   today: parkuseRateData2?parkuseRateData2['todayUseRate']:10,
  //   weekday: parkuseRateData?parkuseRateData['weekendUseRate']:20,
  //   workday: parkuseRateData3?parkuseRateData3['workDayUseRate']:30,
  //   yesterday: parkuseRateData1?parkuseRateData1['yesterdayUseRate']:40
  // }
 
  // let showData = [
  //   { name: '周转提升率', value: Math.round(defaultData.today), index: 0 },
  //   { name: '车位利用率提升率', value: Math.round(defaultData.yesterday), index: 1 },
  //   { name: '高占用车场减少率', value: Math.round(defaultData.workday), index: 2 },
  //   { name: '高占用网格减少率', value: Math.round(defaultData.weekday), index: 3 }
  // ]

  return (
    <Panel
      title="服务成效分析"
    >
      <div className={styles.container}>
        <RadialBar
          width={270}
          height={174}
          autoFit={false}
          data={parkuseRateData}
          xField="name"
          yField="value"
          // maxAngle={maxAngle}
          minBarWidth={6}
          maxBarWidth={6}
          colorField="index"
          color={ref => colors[ref.index]}
          barBackground={{
            style: {
              fill: '#2DABED',
              fillOpacity: 0.19
            }
          }}
          xAxis={{
            label: null
          }}
          barStyle={{
            strokeOpacity: 0
          }}
          radius={0.78}
          innerRadius={0.4}
          tooltip={{
            formatter: data => ({
              name: data.name,
              value: `${data.value}%`
            })
          }}
        />
        <div className={styles.legend}>
          {
            parkuseRateData.map((item:any) => (
              <div className={styles.legend_item} key={item.index}>
                <div>{item.name}</div>
                <div>{item.value}%</div>
              </div>
            ))
          }
        </div>
      </div>
    </Panel>
  )
}

export default KeyCarTable;